<template>
  <div id="invite__list">
    <TopBar :is-show-area-button="false" :welcome="false" @user="isShowUser = true" />
    <div class="list">
      <Item
        v-for="item in list"
        :data="item"
        :key="item.name"
        :color="item.color"
        :background="item.background"
      />
    </div>
    <NavFooter />
    <User v-if="isShowUser" @close="isShowUser = false" />
  </div>
</template>

<script>
import Item from "./Item"
import User from "@/components/my/User"
import NavFooter from "@/components/public/footer"
import TopBar from "@/components/public/top"

export default {
  name: "InviteList",
  components: { Item, NavFooter, TopBar, User },
  data() {
    return {
      isShowUser: false,
      list: null,
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  methods: {
    async getList() {
      const { value_1 } = await this.$api.api.CUSTOM("invite_promo_list")
      this.list = JSON.parse(value_1)
    },
  },
  created() {
    this.getList()
  },
}
</script>

<style lang="scss" scoped>
// @import "../../../../static/css/public.scss";

#invite__list {
  padding-top: 35px;
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
  margin: 20px auto;
  width: 90%;
  background: white;
}

.empty {
  height: 80vh;
}
.list {
}
.animated {
  animation-delay: 0s !important;
  animation-duration: 0.5s !important;
}
</style>
